import { Moon, Sun } from "lucide-react"
import { Button } from "../ui/button"
import { useTheme } from "../lib/theme-provider"

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme()
  const nextTheme = resolvedTheme === "dark" ? "light" : "dark"
  const label = `Switch to ${nextTheme} mode`

  return (
    <Button
      variant="outline"
      size="icon"
      className="shadow-[0_2px_8px_rgb(15_23_42_/_0.14)] transition-colors"
      data-testid="button-theme-toggle"
      aria-label={label}
      title={label}
      onClick={() => setTheme(nextTheme)}
    >
      {resolvedTheme === "dark" ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
    </Button>
  )
}
